import React, { useState } from "react";

import { Button } from "primereact/button";
import { T } from "services/lang/LanguageService";
import MaintenanceFormDialog from "./MaintenanceFormDialog";

const MaintenanceDialogButton: React.FC = () => {
  const [showDialog, setShowDialog] = useState(false);
  return (
    <div className="flex">
      <Button type="button" size="small" label={T("action.create-new")} icon="pi pi-plus" onClick={() => setShowDialog(true)} />
      <MaintenanceFormDialog showDialog={showDialog} setShowDialog={setShowDialog} />
    </div>
  );
};

export default MaintenanceDialogButton;
